<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">Dados Do
            <strong>Fornecedor</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="boxDadosBasicos">
      <v-flex infoDados>
        <v-card>
           <span class="linhaInfo" v-show="model.tipFornecedor =='J'">
            <v-icon>business</v-icon>
            {{$t('label.razaoSocial')}}:
            <strong class="text-cinza-6">
              <span v-html="retornaIfCadastrado(model.nomFornecedor)"></span>
            </strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='F'">
            <v-icon>perm_identity</v-icon>
            {{$t('label.nome')}}:
            <strong class="text-cinza-6">
              <span v-html="retornaIfCadastrado(model.nomFornecedor)"></span>
            </strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='J' && model.flagEstrangeiro==0">
            <v-icon>edit</v-icon>
            {{$t('label.cnpj')}}:
            <strong
              class="text-cinza-6"
            >{{model.numCgcFornecedor|formatCpfCnpj}}</strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='F' && model.flagEstrangeiro==0">
            <v-icon>edit</v-icon>
            {{$t('label.cpf')}}:
            <strong
              class="text-cinza-6"
            >{{model.numCgcFornecedor|formatCpfCnpj}}</strong>
          </span>
          <span class="linhaInfo" v-show="model.flagEstrangeiro==1">
            <v-icon>edit</v-icon>
            {{$t('label.documentoIdentificacao')}}:
            <strong
              class="text-cinza-6"
            >{{model.numCgcFornecedor}}</strong>
          </span>
          <span class="linhaInfo">
            <v-icon>lock</v-icon>Tipo de Cadastro Solicitado:
            <strong class="text-cinza-6">
              <span v-html="retornaEnumDescricao('tipoCertificado',model.tipoCertificado)"></span>
            </strong>
          </span>
          <span class="linhaInfo">
            <v-icon>date_range</v-icon>Data da Solicitação:
            <strong
              class="text-cinza-6"
            >{{model.dataSolicitacao | dataHoraFormatada}}</strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='J'">
            <v-icon>business</v-icon>
            {{$t('label.nomeFantasia')}}:
            <strong class="text-cinza-6"><span v-html="retornaIfCadastrado(model.nomFantasia)"></span></strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='F'">
            <v-icon>perm_identity</v-icon>
            {{$t('label.nomeSocial')}}:
            <strong class="text-cinza-6">
              <span v-html="retornaIfCadastrado(model.nomSocial)"></span>
            </strong>
          </span>
          
          <span class="linhaInfo">
            <v-icon>settings_cell</v-icon>Telefones:
            <strong class="text-cinza-6">{{model.numTelefone}} / {{model.numCelular}}</strong> -
            <span>Contato:
              <strong class="text-cinza-6">{{model.nomContato}}</strong>
            </span>
          </span>
          
          <span class="linhaInfo">
            <v-icon>perm_phone_msg</v-icon>Fax:
            <strong class="text-cinza-6">
              <span v-html="retornaIfCadastrado(model.numFax)"></span>
            </strong>
          </span>
          
          <span class="linhaInfo">
            <v-icon>mail_outline</v-icon>Emails:
            <strong class="info--text" v-show="model.endEmail">
              <a class="info--text">{{model.endEmail}}</a>
              <a class="info--text" v-show="model.endEmail2">/ {{model.endEmail2}}</a>
              <a class="info--text" v-show="model.endEmail3">/ {{model.endEmail3}}</a>
            </strong>
          </span>
          
          
            <span class="linhaInfo">
              <v-icon>streetview</v-icon>Endereço:
              <strong class="text-cinza-6">
                {{model.endLogradouro}},
                N° {{model.endNumero}},
                <span v-show="model.endComplemento">{{model.endComplemento}},</span>

                {{model.endBairro}},
                
                <!-- endereço para brasileiro -->
                <span v-if="model.flagEstrangeiro==0">
                {{model.endCidade}} 
                  - {{model.codUf}} / {{retornaPais(model.codPais)}},
                Cep: {{model.endCep}}
                </span>

                <!-- endereço para estrangeiro -->
                <span v-else> 
                {{model.nomCidadeEstrangeira}} 
                  - {{model.nomUFEstrangeira}} / {{retornaPais(model.codPais)}},
                Cep: {{model.endCepEstrangeiro}}
                </span>
              </strong>
            </span>
            
            <span class="linhaInfo">
              <v-icon>place</v-icon>Nacionalidade:
              <strong class="text-cinza-6">{{model.flagEstrangeiro==0 ? "Brasileira" : "Estrangeira"}}</strong>
            </span>

          <div v-for="item in documentosDadosBasicos" :key="item.codDocumento">
            <span class="linhaInfo" v-show="model.tipFornecedor =='F' && model.flagEstrangeiro==0">
              <v-icon>assignment_ind</v-icon>{{titleCase(item.nomDocumento)}}:
              <strong class="text-cinza-6">{{item.docSolicitacao.numDocumentoForn}}</strong> -
              Expedição:
              <strong class="text-cinza-6">{{item.docSolicitacao.datExpedicao | dataFormatada}}</strong> -
              Orgão Emissor:
              <strong class="text-cinza-6">{{item.docSolicitacao.nomOrgaoEmissor}}</strong>
              <br>
            </span>
            <span class="linhaInfo" v-show="model.tipFornecedor == 'F'">
  <v-icon>attachment</v-icon>Anexo do Documento:
  <strong>
    <v-icon
      v-if="item.docSolicitacao.arquivoUpload && item.docSolicitacao.arquivoUpload != 'Não Encontrado'"
      :color="(
        item.docSolicitacao.regularidadeFiscTrabSituacao === 2
                ? 'blue'
                : (item.docSolicitacao.regularidadeFiscTrabSituacao === 1)
                  ? 'red'
                  : 'grey'
            )"
            :disabled="!(
              String(item.docSolicitacao.arquivoUpload).includes('https') || 
              (item.docSolicitacao.regularidadeFiscTrabSituacao === 1 && String(item.docSolicitacao.arquivoUpload).includes('.pdf'))
            )"
            @click.native="handleIconClick(item.docSolicitacao.arquivoUpload, item.docSolicitacao.regularidadeFiscTrabSituacao)"
          >
            attach_file
          </v-icon>

          <span
            v-else
            v-html="retornaIfCadastrado(item.docSolicitacao.arquivoUpload)"
          ></span>
        </strong>
      </span>

          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>

import documentosService from "../../../services/documentosFornecService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "resumo-dados-basicos",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio: Object,
    enums: Object
  },
  created() /*Metodo de start do componente*/{
     this.getDocumentos();
  },
  data() {//Declaracao de variaveis
    return {
      boxDadosBasicos: true,
      documentosDadosBasicos: Object
    };
  },
  methods: {//Declaracao de todos os metodos
    retornaPais(cod_Pais) {
      //retorna o pais
      if (!cod_Pais) return "";
      let pais = this.dominio.paises.find(x => x.cod_Pais === cod_Pais);
      return pais ? pais.nomPais : null;
    },
    retornaCategoria(cod_categoria) {
      //retorna a categoria
      if (!cod_categoria) return "";
      let categoria = this.dominio.categoria.find(
        x => x.categoria === cod_categoria
      );
      return categoria ? categoria.descricao : null;
    },
    openBox() {
      //abre o box
      this.boxDadosBasicos = !this.boxDadosBasicos;
    },
    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (!valor || !this.enums[_enum]) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao : null;
    },
    handleIconClick(arquivo,situacao) {
    if (arquivo.includes('https')) {
      window.open(arquivo, '_blank');
    } else if (situacao === 1 && arquivo.includes('.pdf')) {
      this.baixarArquivo(arquivo);
    }
  },
    getDocumentos(){
            documentosService.getDocumentosFornecedorSolicitacao(this.model.idFornecSolicitacao).then(documentos => {

              if (documentos.data.length > 0) {
                this.documentosDadosBasicos = documentos.data.filter(
                  x => x.numHabilitacao === "6"
                );
              }
            });
      }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoDados .v-card {
  padding: 15px;
}

.infoDados .linhaInfo {
  display: block;
  padding: 5px 0;
}
</style>
